export default __webpack_public_path__ + "static/media/bsa.e563d2e9.png";